import parseDialogue from "../../util/parseDialogue";

export const SuperphreakD5 = parseDialogue(`
superphreak:d5:100-400

#100 Hey. I can see which program Disarray's getting. It has to do with rapid simultaneous network communication - flooding a huge number of nodes at once.
>200 Why would he want that?

#200 I don't know. What would Disarray be doing that would affect the whole net? He'd stil have to have hacked every node individually to be able to do anything.
>300 What's the next step?

#300 Keep following him. And watch what he says. I'll keep up my trace and get back to you when I have more. L8r.
>400 Close.
`);
